import { imgUrl } from "./api";
import { templateDataUrl } from "../components/designer/templates";

export const mockupSrc = (product, color, side) => {
  const photo = color?.[`${side}_image`];
  return photo ? imgUrl(photo) : templateDataUrl(product.template, side, color?.hex || "#151515");
};

const loadImg = (src) => new Promise((resolve, reject) => {
  const i = new Image();
  i.crossOrigin = "anonymous";
  i.onload = () => resolve(i);
  i.onerror = reject;
  i.src = src;
});

const place = (ctx, l, size, draw) => {
  ctx.save();
  ctx.translate(l.cx * size, l.cy * size);
  ctx.rotate((l.rot * Math.PI) / 180);
  draw();
  ctx.restore();
};

export async function renderPreview(mockup, layers, size = 900) {
  const c = document.createElement("canvas");
  c.width = c.height = size;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#0E1018";
  ctx.fillRect(0, 0, size, size);
  const m = await loadImg(mockup);
  const k = Math.min(size / m.width, size / m.height);
  ctx.drawImage(m, (size - m.width * k) / 2, (size - m.height * k) / 2, m.width * k, m.height * k);
  if (layers.art) {
    const a = await loadImg(layers.art.src);
    const w = layers.art.w * size;
    const h = w * layers.art.aspect;
    place(ctx, layers.art, size, () => ctx.drawImage(a, -w / 2, -h / 2, w, h));
  }
  for (const t of layers.texts) {
    const px = t.size * size;
    await document.fonts.load(`${px}px "${t.font}"`).catch(() => {});
    place(ctx, t, size, () => {
      ctx.font = `${px}px "${t.font}"`;
      ctx.fillStyle = t.color;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(t.text, 0, 0);
    });
  }
  return new Promise((r) => c.toBlob(r, "image/png"));
}
